import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Shield } from "lucide-react";
import api from "@/lib/api";
import { Reveal, Overline } from "@/components/Reveal";

export default function Services() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/services").then((r) => setItems(r.data.filter((s) => s.category !== "Land Defense"))); }, []);

    return (
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
            <Reveal>
                <Overline>Custom Conjure</Overline>
                <h1 className="mt-3 font-serif text-5xl sm:text-6xl text-cream">Spellwork &amp; Services</h1>
                <p className="mt-4 text-ash max-w-2xl">Custom spells, candle work, cleansings, uncrossing, love work, road openers, and money drawing, each set by hand for your situation.</p>
            </Reveal>

            <Reveal delay={0.05}>
                <Link to="/land-defense" data-testid="services-land-defense" className="group mt-8 flex items-center gap-5 p-6 rounded-2xl bg-surface2 border border-gold/25 hover:border-gold/50 transition-colors">
                    <Shield className="w-9 h-9 text-gold shrink-0" />
                    <div className="flex-1">
                        <h3 className="font-serif text-2xl text-cream">Land Defense &amp; Property Pinning</h3>
                        <p className="text-sm text-ash mt-1">Guard the ground itself, iron in the four corners, sills salted, perimeter sealed for home, farm, or business.</p>
                    </div>
                    <ArrowRight className="w-5 h-5 text-gold group-hover:translate-x-1 transition-transform shrink-0" />
                </Link>
            </Reveal>

            <div className="mt-12 grid md:grid-cols-2 gap-6">
                {items.map((s, i) => (
                    <Reveal key={s.id} delay={(i % 2) * 0.08}>
                        <Link to={`/services/${s.id}`} data-testid={`service-${s.id}`} className="group flex flex-col sm:flex-row gap-6 p-5 rounded-2xl bg-surface border border-gold/10 hover:border-gold/40 transition-colors">
                            <img src={s.image} alt={s.name} className="w-full sm:w-40 h-40 object-cover rounded-xl border border-gold/10" />
                            <div className="flex-1">
                                <div className="text-[10px] uppercase tracking-widest text-faded">{s.category} · {s.duration}</div>
                                <h3 className="mt-2 font-serif text-2xl text-cream group-hover:text-gold transition-colors">{s.name}</h3>
                                <p className="mt-2 text-sm text-ash line-clamp-2">{s.description}</p>
                                <div className="mt-4 flex items-center justify-between">
                                    <span className="text-gold text-lg">${s.price.toFixed(0)}</span>
                                    <span className="inline-flex items-center gap-1 text-sm text-gold">Book <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
                                </div>
                            </div>
                        </Link>
                    </Reveal>
                ))}
            </div>
        </div>
    );
}
